module.exports = __webpack_public_path__ + "img/header-engagementRingsClassic@2x.433f385.jpg";